import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import * as modifyIntakeActions from './modify-intake-form.actions';
import * as sitesActions from '../../permissions/touchpoint/site-list-folder/site-list.actions';
import ModifyIntakeForm from './modify-intake-form';
import { Title } from '../../layout';
import { toastr } from 'react-redux-toastr';
import { LoadingPane } from '../../common';
import * as intakeFormConstants from './intake-form-constants';
import { validateIntakeFormActions } from '../validate-intake-form';

export class CreateIntakeFormComponent extends Component {

  componentDidMount() {
    const { sites, modifyIntakeActions, sitesActions, match, modifyIntake, validateIntakeFormActions } = this.props;
    const { params } = match || {};
    const { siteId, programId } = params || {};
    const { validateForm, clearAnswers, fetchProgramDemographics, populateDemographicsAddValues,
      preserveEdits : setPreserveEdits } = modifyIntakeActions || {};
    const { fetchCompleteSiteList, fetchProgramsForSite } = sitesActions || {};
    const { programLists, siteListState } = sites || {};
    const { preserveEdits } = modifyIntake;
    const siteData = siteListState && siteListState.data && siteListState.data.results;
    const site = siteData && siteData.find(res => res.id === siteId);

    var programsState = siteId && programLists && programLists.get(siteId);
    const { data : programList } = programsState || {};
    const program = programList && programList.find(val => val.id === programId);

    const { validateNewIntakeForm } = validateIntakeFormActions;

    if(!preserveEdits) {
      clearAnswers();
      validateForm(['newValue'], undefined, ['newValueValidation']);
      if(!site) {
        fetchCompleteSiteList();
      }
      if(!program) {
        fetchProgramsForSite(siteId);
      }

      if(!!siteId && !!programId){
        validateNewIntakeForm(siteId, programId, Map({}));
        fetchProgramDemographics(siteId, programId)
        .then(() => {
          populateDemographicsAddValues(siteId, programId);
        });
      }
    }
    setPreserveEdits(false);
  }

  componentDidUpdate(prevProps) {
    const { modifyIntakeActions, modifyIntake, validateIntakeFormActions, match } = this.props;
    const { selectedAddTouchpoint, touchpoints, programDemographics : allProgramsDemographics, newValue } = modifyIntake;
    const touchpointState = touchpoints && touchpoints.get(selectedAddTouchpoint);
    const { data : selectedTouchpoint } = touchpointState || {};
    const { params } = match || {};
    const { siteId, programId } = params || {};
    const programDemographicsState = allProgramsDemographics && allProgramsDemographics.getIn([siteId, programId]);
    const { data : demographicsValue } = programDemographicsState || {};

    const { modifyIntake : oldModifyState, match : oldMatch} = prevProps;
    const { selectedAddTouchpoint : prevTouchpointSelection, touchpoints : prevTouchpoints, programDemographics : prevAllProgramDemographics } = oldModifyState;
    const prevTouchpointState = prevTouchpoints && prevTouchpoints.get(prevTouchpointSelection);
    const { data : prevSelectedTouchpoint } = prevTouchpointState || {};
    const { params : prevParams } = oldMatch || {};
    const { siteId : prevSiteId, programId : prevProgramId } = prevParams || {};
    const prevProgramDemographicsState = prevAllProgramDemographics && prevAllProgramDemographics.getIn([prevSiteId, prevProgramId]);
    const { data : prevDemographicsValue } = prevProgramDemographicsState || {};

    validateIntakeFormActions.shouldValidateNew(siteId, programId, newValue);

    if(selectedTouchpoint && selectedTouchpoint !== prevSelectedTouchpoint ) {
      modifyIntakeActions.populateTouchpointAddValues();
      validateIntakeFormActions.invalidateNewValidationResult();
    }
    if(demographicsValue && demographicsValue !== prevDemographicsValue) {
      modifyIntakeActions.populateDemographicsAddValues(siteId, programId);
    }
  }

  handlePreviewIntakeForm() {
    const { redirectTo, match, modifyIntake, modifyIntakeActions } = this.props;
    const { params } = match || {};
    const { siteId, programId } = params || {};
    const { fetchCurrentFormPreview, updateModifiedPreviewState } = modifyIntakeActions;
    const { newValue } = modifyIntake || {};
    const disableReCaptcha = !!newValue && newValue.get(intakeFormConstants.securitySection);

    updateModifiedPreviewState(null, siteId, programId, disableReCaptcha, intakeFormConstants.editStatus.createNew)
    .then(value => {
      fetchCurrentFormPreview(null, siteId, programId, value);
      redirectTo(`/intake-forms/preview/${intakeFormConstants.createNewIntakeId}`);
    });
  }

  handleAddIntakeForm() {
    const { modifyIntake, modifyIntakeActions, match, redirectTo } = this.props;
    const { newValueValidation } = modifyIntake;
    const { showAddValidation } = modifyIntakeActions;
    const { url } = match || {};

    //if not passing validation
    if(newValueValidation && newValueValidation.length > 0) {
      showAddValidation();
      redirectTo(url);
      return;
    }

    this.saveForm();
  }

  saveForm() {
    const { modifyIntakeActions, redirectTo, match } = this.props;
    const { params } = match || {};
    const { siteId, programId } = params || {};
    const { addForm } = modifyIntakeActions;

    addForm(siteId, programId)
    .then(val => {
      toastr.success('Success', 'Intake Form Saved');
      redirectTo('/intake-forms');
    })
    .catch(err => {
      toastr.error(err.errorCode, err.errorMessage);
    });
  }

  handleUpdateTouchpoint(value) {
    const { modifyIntakeActions, validateIntakeFormActions } = this.props;
    const { selectAddTouchpoint } = modifyIntakeActions || {};

    selectAddTouchpoint(value);
    if(!value) {
      validateIntakeFormActions.invalidateNewValidationResult();
    }
  }

  handleUpdateValue(sections, updateVal, invalidate) {
    const { modifyIntakeActions, validateIntakeFormActions } = this.props;
    const { updateValue, validateForm } = modifyIntakeActions || {};
    var path = ['newValue'];
    path.push(...sections);
    updateValue(path, updateVal);
    validateForm(['newValue'], undefined, ['newValueValidation']);
    if(invalidate) {
      validateIntakeFormActions.invalidateNewValidationResult();
    }
  }

  handleUpdateOrder(section, name, uniqueId, moveUp) {
    const { modifyIntakeActions } = this.props;
    const { updateOrder } = modifyIntakeActions || {};
    var path = ['newValue', section];
    updateOrder(path, name, uniqueId, moveUp);
  }

  render() {
    const { sites, modifyIntake, validateIntake, redirectTo, match } = this.props;
    const { params } = match || {};
    const { siteId, programId } = params || {};
    const { newValueValidation, newValue, addMessageState, showAddValidation, addFormState, selectedAddTouchpoint } = modifyIntake || {};
    const { isFetching } = addMessageState || {};
    const { isFetching : isSaving } = addFormState || { isFetching : false };

    const { programLists, siteListState, isFetchingMultiPageSites } = sites || {};
    const siteData = siteListState && siteListState.data && siteListState.data.results;
    const site = siteData && siteData.find(res => res.id === siteId);
    const siteName = site ? site.name : '';

    var programsState = siteId && programLists && programLists.get(siteId);
    const { isFetching : programsLoading, data : programList } = programsState || {};
    const program = programList && programList.find(val => val.id === programId);
    const programName = program ? program.name : '';
    const siteAndProgram = !!siteName && !!programName ? ` for ${siteName} / ${programName}` : '';

    var validationState = validateIntake.get('newFormValidation');
    const { data: intakeValidationResult, isFetching : loadingValidation, err : validationErr } = validationState || { data: { passedValidation : true } };

    return (
      <LoadingPane isLoading={isFetchingMultiPageSites || programsLoading} loadingMessage={'Loading intake form...'}>
        <Title title="Create Intake Form"/>
        <ModifyIntakeForm
          match={match}
          title={`New Intake Form${siteAndProgram}`}
          siteId={siteId}
          programId={programId}
          value={newValue}
          updateOrder={(section, name, uniqueId, moveUp) => this.handleUpdateOrder(section, name, uniqueId, moveUp)}
          updateValue={(sections, updateVal, invalidate) => this.handleUpdateValue(sections, updateVal, invalidate)}
          disabled={isFetching}
          errors={newValueValidation}
          showErrors={showAddValidation}
          selectedTouchpointId={selectedAddTouchpoint}
          updateTouchpoint={(val) => this.handleUpdateTouchpoint(val)}
          isSubmitting={isSaving}
          loadingValidation={loadingValidation}
          validationErr={validationErr}
          intakeValidationResult={intakeValidationResult}
          onSave={() => this.handleAddIntakeForm()}
          onCancel={() => redirectTo('/intake-forms')}
          onPreview={() => this.handlePreviewIntakeForm()}
          formMode={intakeFormConstants.editStatus.createNew} />
      </LoadingPane>
    );
  }
}

CreateIntakeFormComponent.propTypes = {
  modifyIntake : PropTypes.any,
  modifyIntakeActions : PropTypes.any,
  redirectTo : PropTypes.func,
};

const mapStateToProps = ({ modifyIntake, sites, validateIntake }) => {
  return {
    modifyIntake,
    sites,
    validateIntake,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    modifyIntakeActions: bindActionCreators(modifyIntakeActions, dispatch),
    sitesActions: bindActionCreators(sitesActions, dispatch),
    validateIntakeFormActions: bindActionCreators(validateIntakeFormActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateIntakeFormComponent);
